import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RootLayout } from '../root/root.component';
import { FilterService } from '../../../services/filter.service';
import { pagesToggleService } from '../../services/toggler.service';
import { Router } from '@angular/router';

import * as $ from "jquery";
import { AuthService } from '../../../feature-modules/admin/admin-services/auth.service';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../feature-modules/admin/service/notification.service';
import { environment } from '../../../../environments/environment';
import { EncriptDecriptService } from '../../../services/encriptdecript';

@Component({
  selector: 'app-users-layout',
  templateUrl: './users-layout.component.html',
  styleUrls: ['./users-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UsersLayoutComponent extends RootLayout implements OnInit {
  public obj: any;
  public roleName: boolean = false;
  menuLinks = [
    {
      label: 'Dashboard',
      // details: '12 New Updates',
      routerLink: 'dashboard',
      iconType: 'pg',
      iconName: 'home'

      
    },
    {
      label: 'Users',
      // details: '12 New Updates',
      routerLink: 'users',
      iconType: 'fa',
      iconName: 'user'
    },
    {
      label: 'Courses',
      // details: '12 New Updates',
      routerLink: 'courses',
      iconType: 'fa',
      iconName: 'newspaper-o'
    },
    {
      label: 'App Management',
      // details: '12 New Updates',
      routerLink: 'app_management',
      iconType: 'pg',
      iconName: 'settings_small'
    },
    {
      label: 'Billing',
      // details: '12 New Updates',
      routerLink: 'billing',
      iconType: 'fa',
      iconName: 'money'
    }
  ];

  // profile complete status Value
  prof_val = 80;
  FirstName: '';
  UserRoleName: any;
  // imageUrl: any;
  sample: any;
  isAdmin: boolean = false;
  public filterTerm = '';
  imageUrl: string;
  public bannerPath;
  public userDetails: any;
  // this.dashbaordHeader = this.authService.redirectUrl ? this.authService.redirectUrl : '/home';
  // this.router.navigate([this.redirectUrl]);

  // tslint:disable-next-line:no-shadowed-variable
  constructor(private filterService: FilterService, private userService: UserService,
    private notificationService: NotificationService,
    private encriptDecript: EncriptDecriptService,
    public toggler: pagesToggleService, public router: Router,
    private adminAuth: AuthService) {
    super(toggler, router);
  }



  ngOnInit() {
    this.changeLayout('menu-pin');
    this.changeLayout('menu-behind');
    // Will sidebar close on screens below 1024
    this.autoHideMenuPin();
    this.userDetails = this.encriptDecript.getLocalStorage('userObject');
    this.obj = JSON.parse(this.userDetails);
    this.FirstName = this.obj.firstName;
    this.isAdmin = this.obj.isAdmin;
    const ftpHost = environment['ftpHost'] + environment['ftpRootDir'];
    this.bannerPath = ftpHost ? ftpHost : environment['cloudPath'];
    if (
      this.obj.organisation.logoPath != undefined &&
      this.obj.organisation.logoPath != null
    ) {
      this.imageUrl = this.bannerPath + this.obj.organisation.logoPath;
    } else {
      this.imageUrl = 'assets/img/logo/hornbill-logo-3.png';
    }
    if (!this.obj.isAdmin) {
      this.UserRoleName = this.obj.roles[0].name;
    }
    this.filterTerm = '';
    // this.filterService.filterTerm.subscribe(term => this.filterTerm = term);

    $(document).ready(function () {
      /*Dropdown Menu*/
      $('.dropdown-filter').click(function () {
        $(this).attr('tabindex', 1).focus();
        $(this).toggleClass('active');
        $(this).find('.dropdown-menu-filter').slideToggle(300);
      });
      $('.dropdown-filter').focusout(function () {
        $(this).removeClass('active');
        $(this).find('.dropdown-menu-filter').slideUp(300);
      });
      $('.dropdown-filter .dropdown-menu-filter li').click(function () {
        $(this).parents('.dropdown-filter').find('span').text($(this).text());
        $(this).parents('.dropdown-filter').find('input').attr('value', $(this).attr('id'));
      });
      /*End Dropdown Menu*/

    });

    this.isAdminAccess();
    this.getRoleName();
  }

  public isAdminAccess() {
    return this.adminAuth.isAunthenticated();
  }
  public newFilter(filterTerm) {
    this.filterService.changeMessage(filterTerm);
  }

  getRoleName() {
    const role = this.obj.roles[0];
    for (let i = 0; i < role.applicationRolePermission.length; i++) {
      if (role.applicationRolePermission[i].isUpdate ||
        role.applicationRolePermission[i].isWrite ||
        role.applicationRolePermission[i].isDelete) {
        this.roleName = true;
      }
    }
  }

  logout() {
    // const userId=  this.obj.userId;
    var logo = localStorage.getItem('logo');
    this.userService.logOut(this.obj.userId).subscribe(response => {
      this.router.navigate(['/login/', logo]);
      localStorage.clear();
      sessionStorage.clear();
    }, (error) => {
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/layouts/users-layout/users-layout.component.ts